<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Basics/Gold.html')">店铺管理</div></el-breadcrumb-item>
            <el-breadcrumb-item>店铺等级</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="btns">
            <el-button type="primary" size="small" @click="add" v-auth="['admin/business.storeRank/add']">添加店铺等级</el-button>
            <el-button type="danger" size="small" @click="delAll" v-auth="['admin/business.storeRank/delete']">批量删除</el-button>

        </div>
        <!--		数据是list 通过list展示-->
        <el-table :data="list" border @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="service_fee" label="服务费"></el-table-column>
            <el-table-column prop="quantity" label="可发布商品数"></el-table-column>
            <el-table-column prop="memo" label="备注"></el-table-column>
            <el-table-column prop="orders" label="排序"></el-table-column>
            <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['admin/business.storeRank/update']">编辑</el-button>
                    <el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10" v-auth="['admin/business.storeRank/delete']">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                list:[],
                isLoad:false,
                pageSize:20,
                total:0,
                page:1,
                multipleSelection:[]
            }
        },
        created() {
            this.loadList()
        },
        methods: {
			gotopage(url){
				var link =  this.$router.resolve({
					path: url
				});
				window.open(link.href, '_blank')
			},
            loadList(){
                if(this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/admin/business.storeRank/list',{
                    page: this.page,
                    limit: this.pageSize
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 获取数据
                        this.list = res.data.list.data
                        // 页数 page
                        this.total = res.data.list.total
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            // 跳转到edit添加
            add(){
                this.$router.push({path: '/Basics/GoldEdit.html'});
            },
            // 传一个ID跳转到edit页面，进行编辑
            edit(id){
                this.$router.push({
                    path:'/Basics/GoldEdit.html',
                    query:{
                        id:id
                    }
                });
            },
            //
            del(id){
                if(this.isLoad){
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/business.storeRank/delete', {
                    data: {
                        ids: id
                    }
                })
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '删除成功',
                            showClose:false
                        });
                        this.loadList()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },

            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAll(){
                let id = []
                for(let key in this.multipleSelection){
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if(this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/business/storeRank/delete', {
                    data: {
                        ids: id
                    }
                }).then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '删除成功',
                            showClose:false
                        });
                        this.loadList()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },

            sizeReload(val){
                this.pageSize = val
                this.loadList()
            },
            pageReload(val){
                this.page = val
                this.loadList()
            }
        }
    }
</script>
<style scoped>
</style>
